import { IconProps } from "./types";

interface CircleCheckProps extends IconProps {
    variant?: "regular" | "curvy";
}

const CircleCheck = ({ color = "#FF6A3C", variant = "regular", onClick, ...props }: CircleCheckProps) => {
    return variant === "regular" ? (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
            <rect
                x="24"
                y="24"
                width="24"
                height="24"
                rx="12"
                transform="rotate(-180 24 24)"
                fill={color}
                onClick={onClick}
                className="cursor-pointer"
            />
            <path
                d="M10.4733 16C10.1691 16 9.88095 15.884 9.69632 15.684L7.19756 12.986C7.12031 12.9027 7.06391 12.8077 7.03159 12.7066C6.99926 12.6055 6.99165 12.5001 7.00919 12.3965C7.02673 12.293 7.06907 12.1933 7.13379 12.1031C7.19851 12.0129 7.28435 11.9341 7.38639 11.871C7.48839 11.8077 7.60468 11.7615 7.7286 11.735C7.85251 11.7085 7.98161 11.7022 8.10849 11.7165C8.23537 11.7309 8.35754 11.7655 8.46801 11.8185C8.57847 11.8715 8.67505 11.9418 8.75221 12.0253L10.3964 13.7992L14.5302 8.37472C14.6673 8.19561 14.8857 8.06826 15.1376 8.02058C15.3894 7.97291 15.6541 8.00881 15.8736 8.12041C16.3303 8.35243 16.4709 8.8439 16.1855 9.21765L11.3013 15.624C11.2179 15.7338 11.103 15.8254 10.9665 15.8907C10.83 15.956 10.6761 15.9932 10.5181 15.9989C10.5027 16 10.4887 16 10.4733 16Z"
                fill="white"
            />
        </svg>
    ) : (
        <svg width="26" height="26" viewBox="0 0 26 26" fill="none" {...props}>
            <path
                d="M22.9562 8.65125C22.985 8.43375 23 8.21625 23 8C23 5.02625 20.3212 2.64 17.3487 3.04375C16.4825 1.5025 14.8325 0.5 13 0.5C11.1675 0.5 9.5175 1.5025 8.65125 3.04375C5.6725 2.64 3 5.02625 3 8C3 8.21625 3.015 8.43375 3.04375 8.65125C1.5025 9.51875 0.5 11.1687 0.5 13C0.5 14.8312 1.5025 16.4812 3.04375 17.3487C3.01491 17.5646 3.0003 17.7822 3 18C3 20.9737 5.6725 23.3537 8.65125 22.9562C9.5175 24.4975 11.1675 25.5 13 25.5C14.8325 25.5 16.4825 24.4975 17.3487 22.9562C20.3212 23.3537 23 20.9737 23 18C23 17.7837 22.985 17.5662 22.9562 17.3487C24.4975 16.4812 25.5 14.8312 25.5 13C25.5 11.1687 24.4975 9.51875 22.9562 8.65125ZM11.6937 18.52L7.11 13.8775L8.89 12.1225L11.7112 14.98L17.12 9.6125L18.88 11.3875L11.6937 18.52Z"
                fill="#FF6A3C"
            />
        </svg>
    );
};

export default CircleCheck;
